null


// WEBPACK FOOTER //
// https://raw.githubusercontent.com/scala-js/scala-js/v0.6.32/javalanglib/src/main/scala/java/lang/Double.scala